import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import PostService from '../../services/PostService'
import { PostDTO } from '../../models/post'
import Post from '../home/Post'
import CustomPaper from '../../containers/Paper'
import { CircularProgress } from '@mui/material'
import GoBackButton from '../../components/GoBackButton'

const SinglePostPage = () => {
    const { state } = useLocation()
    const { postId } = useParams<{ postId: string }>()
    const [post, setPost] = useState<PostDTO>()
    const [mutate, setMutate] = useState<boolean>(false)
    const navigate = useNavigate()

    useEffect(() => {
        if (!postId) return
        new PostService().getPostById(postId).then((response) => {
            if (response.status === 200) setPost(response.data)
        })
    }, [postId, mutate])

    return (
        <>
            {post ? (
                <div className="flex flex-col gap-2 w-full">
                    {state?.goBackPath && (
                        <div className="w-fit flex gap-2 items-center">
                            <GoBackButton navigate={() => navigate(state?.goBackPath)} />
                            <span className="text-xl font-semibold text-secondary">
                                Volver atrás
                            </span>
                        </div>
                    )}
                    <CustomPaper>
                        <Post
                            single
                            info={post}
                            setMutate={setMutate}
                        />
                    </CustomPaper>
                </div>
            ) : (
                <div className="flex w-full justify-center">
                    <CircularProgress
                        className="m-2 md:m-5 text-primary"
                        size={64}
                    />
                </div>
            )}
        </>
    )
}

export default SinglePostPage
